<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <h1 class="page-title pull-left">Spray Sessions</h1>
      </div>
    </div>


    <div class="panel">
      <div class="panel-body">
        <div class="filter-container">
          <section>
            <header>Filter Spray Sessions for Viewing</header>
            <div class="input-row">
              <div>
                <label>Start Date:</label>
                <input type="date" v-model="startedAt" />
              </div>
              <div v-if="filterOptions.zones.length">
                <label>Zone:</label>
                <Dropdown v-model="zoneId" :objects="filterOptions.zones" />
              </div>
              <div v-if="filterOptions.trucks.length">
                <label>Truck:</label>
                <Dropdown v-model="truckId" :objects="filterOptions.trucks" />
              </div>
            </div>

            <div class="input-row">
              <div>
                <label>End Date:</label>
                <input type="date" v-model="endedAt" />
              </div>
              <div v-if="filterOptions.contracts.length">
                <label>Contract:</label>
                <Dropdown v-model="contractId" :objects="filterOptions.contracts" />
              </div>
              <div v-if="filterOptions.applicators.length">
                <label>Driver:</label>
                <Dropdown v-model="applicatorId" :objects="filterOptions.applicators" />
              </div>
            </div>

            <div class="input-row">
              <div v-if="filterOptions.achemicals.length">
                <label>Chemical:</label>
                <Dropdown v-model="achemicalId" :objects="filterOptions.achemicals" />
              </div>
            </div>

            <div class="buttons">
              <Button type="primary" @click="filter()">
                Search Adulticide Spray Sessions
              </Button>
              <Button type="clear" @click="clearFilters()">
                Clear
              </Button>
            </div>
          </section>
        </div>
        <div class="table-container">
          <div v-if="errorMessage" class="error-container">
            <div class="error-message">
              {{ errorMessage }}
            </div>
          </div>
          <Table :isLoading="false" />
        </div>
        <div class="buttons">
          <router-link :to="{ name: 'spray-paths-map' }">
            <Button type="primary" href="#">
              View Selected Spray Sessions on Map
            </Button>
          </router-link>

          <Button type="primary" @click="runReport()">
            <i class="fa fa-circle-o-notch fa-spin" v-if="reportLoading"></i>
            <span v-if="!reportLoading">
              Pull GUMA Report for Selected Spray Sessions
            </span>
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
``
import moment from "moment";

import { mapGetters, mapState } from "vuex";
import Table from '@/components/spray-paths/table';
import Dropdown from "@/components/spray-paths/dropdown";
import Button from '@/components/button';
import AdulticideService from "../services/v2/AdulticideService";
import reports from '@/utils/reports';
import ReportsService from '@/services/ReportsService';

export default {
  name: 'spray-paths',

  components: {
    Table,
    Dropdown,
    Button,
  },

  data() {
    var today = new Date();
    var momentToday = moment(today);
    var oneWeekAgo = today;
    oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
    var momentOneWeekAgo = moment(oneWeekAgo);
    return {
      loadingData: false,
      reportLoading: false,
      startedAt: momentOneWeekAgo.format("YYYY-MM-DD"),
      endedAt: momentToday.format("YYYY-MM-DD"),
      zoneId: null,
      truckId: null,
      contractId: null,
      applicatorId: null,
      achemicalId: null,
      errorMessage: null,
      filterOptions: {
        zones: [],
        trucks: [],
        contracts: [],
        applicators: [],
        achemicals: [],
      }
    };
  },

  computed: {
    ...mapGetters(['mapAdulticides']),
    ...mapState({
      adulticides: (state) => state.sprayPaths.adulticides,
    }),

    startedAtMoment() {
      return moment(this.startedAt);
    },

    endedAtMoment() {
      return moment(this.endedAt);
    },

    filterKeys() {
      return Object.keys(this.filters);
    },
  },

  methods: {
    getFilterOptions() {
      AdulticideService.filterOptions().then((res) => {
        const { zones, trucks, contracts, applicators, achemicals } = res;
        this.filterOptions.zones = zones;
        this.filterOptions.trucks = trucks;
        this.filterOptions.contracts = contracts;
        this.filterOptions.applicators = applicators;
        this.filterOptions.achemicals = achemicals;
      }).catch((error) => {
        console.log('error', error)
      });
    },

    clearFilters() {
      this.startedAt = moment().subtract(7, 'days').format("YYYY-MM-DD");
      this.endedAt = moment().format("YYYY-MM-DD");
      this.zoneId = null;
      this.truckId = null;
      this.contractId = null;
      this.applicatorId = null;
      this.achemicalId = null;
    },

    filter() {
      this.errorMessage = null;
      this.$store.commit("setIsLoading", true);
      this.$store.commit('setDataLoaded', false);
      this.$store.commit('clearAdulticides');

      const startDate = this.startedAtMoment.format("YYYY-MM-DD");
      const endDate = this.endedAtMoment.format("YYYY-MM-DD");
      const { zoneId, truckId, contractId, applicatorId, achemicalId } = this;

      const params = {
        startDate,
        endDate,
        zoneId,
        truckId,
        contractId,
        applicatorId,
        achemicalId,
      };

      AdulticideService.index(params).then(({ adulticides }) => {
        adulticides.forEach((adulticide) => {
          console.log('adulticide', adulticide)
          this.$store.commit('addAdulticide', adulticide);
        });
      }).catch((error) => {
        console.log('error', error);
        this.errorMessage = error.message;
      }).finally(() => {
        this.$store.commit("setIsLoading", false);
        this.$store.commit('setDataLoaded', true);
      });
    },

    runReport() {
      const checkedFilter = ({ checked }) => checked;
      const checkedAdulticides = this.$store.state.sprayPaths.adulticides.filter(
        checkedFilter
      );
      this.reportLoading = true;
      let data = {
        adulticides: reports.getId(checkedAdulticides),
      };
      ReportsService.report('guma', data)
        .then((data) => {
          this.reportLoading = false;
          window.open(data.url, '_blank');
        })
        .catch((error) => {
          this.reportLoading = false;
          toastr.error(
            `Sorry, there was an error generating the report. ${error.message}`
          );
        });
    }
  },

  async mounted() {
    this.getFilterOptions();
    this.filter();
  },
};
</script>

<style scoped lang="scss">
@import "../assets/scss/variables";

header {
  font-size: 1.05em;
  margin-bottom: 2rem;
}

header,
label {
  color: $section-header-text-color;
  font-weight: 500;
}

.input-row {
  display: flex;
  margin-bottom: 1rem;

  &>div {
    max-width: 33%;
    margin-right: 4rem;
  }

  label {
    width: 100px;
  }

  input,
  select {
    width: 240px;
    padding: 4px;
    border-radius: 2px;
    box-shadow: 0 0.5px 1px 0 rgba(0, 0, 0, 0.15);
    border: 1px solid $gray-bg;
  }
}

div.error-container {
  border: 1px solid #ff0000;
  border-radius: 2px;
  background-color: #ffcccc;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1rem;
  margin: 1rem auto;
}

div.error-message {
  color: #ff0000;
  font-size: 0.9em;
  font-weight: 500;
  margin: 0 auto;
  margin-top: 1rem;
  padding: 1rem;
}

.buttons {
  margin: 1rem 0;

  &>* {
    margin-right: 2rem;
  }
}
</style>
